<template>
    <div class="flex flex-col mx-auto max-w-lg w-full text-left"> 
        <form @submit.prevent="validateCustomer" class="flex flex-col space-y-10 w-full py-5">
            <div class="flex flex-col space-y-3">
                <span class="text-2xl">Identité</span>
                <aff-input label="Genre" v-model="customer.gender" type="select" :options="[{label: 'Mme'}, {label: 'M.'}]" />
                
                <div class="flex space-x-3">
                    <aff-input required label="Prénom" v-model="customer.firstname" />
                    <aff-input required label="Nom" v-model="customer.lastname" />
                </div>

                <aff-input required label="Date de naissance" v-model="customer.birthdate" type="date" />
            </div>

            <div class="flex flex-col space-y-3">
                <span class="text-2xl">Adresse</span>
                <aff-input required label="Adresse" v-model="customer.address_1" />
                <aff-input label="Complément de l'adresse" v-model="customer.address_2"/>

                <div class="flex space-x-3">
                    <aff-input required label="Code postal" v-model="customer.address_postcode" />
                    <aff-input required label="Ville" v-model="customer.address_city"  />
                </div>
            </div>

            <div class="flex flex-col space-y-3">
                <span class="text-2xl">Contact</span>
                <aff-input required label="Numéro de téléphone" v-model="customer.phone"  />
                <aff-input required type="email" label="E-mail" v-model="customer.email" />
            </div>

            <input type="submit" value="Passer à la dernière étape" class="p-4 px-8 cursor-pointer bg-green-500 hover:bg-green-600 text-white rounded ml-auto disabled:opacity-75 disabled:cursor-not-allowed"/>
        </form>
    </div>
</template>

<script>
import AffInput from '@/components/inputs/AffInput'

export default {
    components: { AffInput },
    props: ['customerPrevious'],
    data: function () {
        return {
            customer: {
                gender: null,
                firstname: null,
                lastname: null,
                email: null,
                phone:null,
                address_1: null,
                address_2: null,
                address_city: null,
                address_postcode: null,
                address_country: 'FR',
                birthdate: null
            },
            errors: null
        };
    },
    mounted: function () {
        if(this.customerPrevious) {
            this.customer = this.customerPrevious;
        }
    },
    methods: {
        validateCustomer: function () {
            this.$emit('validate-customer', this.customer);
        }
    }
}
</script>